/** Resolve deployment branches from API payload (supports legacy single branch). */
export function getRepoDeploymentBranches(repo: {
  deploymentBranches?: string[] | null;
  deploymentBranch?: string | null;
  defaultBranch?: string | null;
} | null | undefined): string[] {
  if (!repo) return ['main'];
  if (Array.isArray(repo.deploymentBranches) && repo.deploymentBranches.length > 0) {
    return repo.deploymentBranches.filter((b) => String(b).trim() !== '');
  }
  if (repo.deploymentBranch && String(repo.deploymentBranch).trim() !== '') {
    return [String(repo.deploymentBranch).trim()];
  }
  return [repo.defaultBranch || 'main'];
}
